export type SupportedLanguageEnglishName =
  | 'English'
  | 'Spanish'
  | 'French'
  | 'Japanese'
  | 'German'
  | 'Italian'
  | 'Portuguese'
  | 'Chinese, Simplified'
  | 'Korean';

export type SupportedLanguageLocalName =
  | 'English'
  | 'español'
  | 'français'
  | '日本語'
  | 'Deutsch'
  | 'italiano'
  | 'português'
  | '中文(简体)'
  | '한국어';

export const allSupportedLanguagesCodes = [
  'en',
  'es',
  'de',
  'it',
  'fr',
  'ja',
  'pt',
  'zh',
  'ko',
] as const;

export const languageCodeToEnglishName: Record<
  SupportedLanguageCode,
  SupportedLanguageEnglishName
> = {
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  ja: 'Japanese',
  de: 'German',
  it: 'Italian',
  pt: 'Portuguese',
  zh: 'Chinese, Simplified',
  ko: 'Korean',
};

export function getLanguageEnglishNames(
  languageCodes: SupportedLanguageCode[],
): SupportedLanguageEnglishName[] {
  return languageCodes.map((code) => languageCodeToEnglishName[code]);
}

export type SupportedLanguageCode = (typeof allSupportedLanguagesCodes)[number];
